import ToggleBadge from "src/components/ToggleBadge";
import useGatheringFilterSortStore from "../../../hooks/useGatheringFilterSortStore";

const GatheringFilterSortAllPeopleToggle = ({ userId }: { userId: string }) => {
	const isSelected = useGatheringFilterSortStore((state) => state.filterUserIds.includes(userId));
	return <ToggleBadge isSelected={isSelected} variant={"MultiSelect"} />;
};

export default GatheringFilterSortAllPeopleToggle;
